// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__cmKwK","info":"Note_info__GJXXL","note":"Note_note__1G-hA","actions":"Note_actions__2WxB2"};